import blocks from './blocks'
import trends from './trends'

export default [
  {
    title: 'CH. 1',
    description: 'Forward',
    identifier: 'ch1',
    children: [
      {
        title: 'Introducing the Moda Operandi Runway Report'
      }
    ]
  },
  {
    title: 'CH. 2',
    description: 'The Findings',
    identifier: 'ch2',
    children: [
      ...blocks.map((block) => ({
        title: block.title,
        identifier: block.name
      })),
      ...trends.map((trend, index) => ({
        title: trend.title,
        identifier: trend.identifier
      })),
      {
        title: 'The Top Colors',
        identifier: 'the-top-colors'
      }
    ]
  },
  {
    title: 'CH. 3',
    description: 'Digging Deeper',
    identifier: 'ch3',
    children: [
      {
        title: 'Style by the State',
        identifier: 'style-by-state'
      },
      {
        title: 'Who New Yorkers are Wearing This Fall',
        identifier: 'nyc-fall'
      },
      {
        title: 'The Most Runway-Obsessed Cities',
        identifier: 'runway-obsessed-cities'
      },
      {
        title: 'Full Looks',
        identifier: 'full-looks'
      }
    ]
  }
]
